export enum DocumentModalNames {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
}